import { Box, InputBase } from '@material-ui/core';
import { alpha, makeStyles, Theme } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import React from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  search: {
    borderRadius: theme.shape.borderRadius,
    '&:hover, &:focus-within': {
      backgroundColor: alpha(theme.palette.common.black, 0.05),
    },
  },
  icon: {
    padding: theme.spacing(0, 3),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  inputInput: {
    padding: theme.spacing(1.5, 1.5, 1.5),
    paddingLeft: `calc(1em + ${theme.spacing(6)}px)`,
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      paddingLeft: theme.spacing(1.5),
    },
  },
  inputRoot: {
    width: '100%',
  },
}));

export default function AppSearch(): JSX.Element {
  const classes = useStyles();

  return (
    <Box className={classes.search} position="relative" width="auto">
      <div className={classes.icon}>
        <SearchIcon />
      </div>
      <InputBase
        placeholder="Search…"
        classes={{
          root: classes.inputRoot,
          input: classes.inputInput,
        }}
        inputProps={{ type: 'search', 'aria-label': 'search' }}
      />
    </Box>
  );
}
